import Notify from 'klicknotify';
import RDStation from '../../../services/request/rdstation';
import router from '../../../router';
import i18n from '../../../i18n';

const rdstation = new RDStation();

const actions = {};

actions.authorizeRDStation = ({ commit }, account) =>
  rdstation.post('authorize', account)
    .then(response => window.open(response.data, '_self'))
    .catch(error => Notify.error({ message: error.response.data.message, autoHide: true }));

actions.getResponseCode = ({ rootState }, account) => {
  const { id, name, type } = account;
  const { route: { query: { code } } } = rootState;

  const accountParams = {
    code,
    id,
    name,
    type,
  };

  return rdstation.put('set_account', accountParams)
    .then(() => {
      Notify.success({ message: i18n.t('account.notify.success.create'), autoHide: true });
      router.push({ name: 'Index' });
    })
    .catch(() => {
      Notify.error({ message: i18n.t('account.notify.error.rdstation'), autoHide: true });
      router.push({ name: 'Index' });
    });
};

export default actions;



// WEBPACK FOOTER //
// ./src/screens/RDStation/store/actions.js